import config from 'config'
import { initializeBotDetection } from 'utils/bots/detection/botDetection'

// Bot detection is only active in Germany.
if (config.locale === 'de-de') {
  initializeBotDetection()
}
